/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation
} from '@tanstack/vue-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationReturnType
} from '@tanstack/vue-query';

import {
  toValue
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  ConfirmAccessCodeInput,
  ConfirmAccessEmailResponse,
  ConfirmAccessInput,
  SessionInput,
  StandardError,
  StandardMessage,
  User
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary create session
 */
export const createSession = (
    sessionInput: MaybeRefOrGetter<SessionInput>,
 signal?: AbortSignal
) => {
      sessionInput = toValue(sessionInput);

      return axiosClient<User>(
      {url: `/sessions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sessionInput, signal
    },
      );
    }




export const getCreateSessionMutationOptions = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSession>>, TError,{data: SessionInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createSession>>, TError,{data: SessionInput}, TContext> => {

const mutationKey = ['createSession'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSession>>, {data: SessionInput}> = (props) => {
          const {data} = props ?? {};

          return  createSession(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSessionMutationResult = NonNullable<Awaited<ReturnType<typeof createSession>>>
    export type CreateSessionMutationBody = SessionInput
    export type CreateSessionMutationError = ErrorType<StandardError>

    /**
 * @summary create session
 */
export const useCreateSession = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSession>>, TError,{data: SessionInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createSession>>,
        TError,
        {data: SessionInput},
        TContext
      > => {
      return useMutation(getCreateSessionMutationOptions(options), queryClient);
    }
    /**
 * @summary Destroy Session
 */
export const destroySession = (

 signal?: AbortSignal
) => {


      return axiosClient<StandardMessage>(
      {url: `/sessions`, method: 'DELETE', signal
    },
      );
    }




export const getDestroySessionMutationOptions = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroySession>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroySession>>, TError,void, TContext> => {

const mutationKey = ['destroySession'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroySession>>, void> = () => {


          return  destroySession()
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroySessionMutationResult = NonNullable<Awaited<ReturnType<typeof destroySession>>>

    export type DestroySessionMutationError = ErrorType<StandardError>

    /**
 * @summary Destroy Session
 */
export const useDestroySession = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroySession>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroySession>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDestroySessionMutationOptions(options), queryClient);
    }
    /**
 * @summary confirm_access session
 */
export const confirmAccess = (
    confirmAccessInput: MaybeRefOrGetter<ConfirmAccessInput>,
 signal?: AbortSignal
) => {
      confirmAccessInput = toValue(confirmAccessInput);

      return axiosClient<StandardMessage>(
      {url: `/sessions/confirm-access`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: confirmAccessInput, signal
    },
      );
    }




export const getConfirmAccessMutationOptions = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmAccess>>, TError,{data: ConfirmAccessInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof confirmAccess>>, TError,{data: ConfirmAccessInput}, TContext> => {

const mutationKey = ['confirmAccess'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmAccess>>, {data: ConfirmAccessInput}> = (props) => {
          const {data} = props ?? {};

          return  confirmAccess(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConfirmAccessMutationResult = NonNullable<Awaited<ReturnType<typeof confirmAccess>>>
    export type ConfirmAccessMutationBody = ConfirmAccessInput
    export type ConfirmAccessMutationError = ErrorType<StandardError>

    /**
 * @summary confirm_access session
 */
export const useConfirmAccess = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmAccess>>, TError,{data: ConfirmAccessInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof confirmAccess>>,
        TError,
        {data: ConfirmAccessInput},
        TContext
      > => {
      return useMutation(getConfirmAccessMutationOptions(options), queryClient);
    }
    /**
 * @summary Verify confirm access code
 */
export const verifyConfirmAccessCode = (
    confirmAccessCodeInput: MaybeRefOrGetter<ConfirmAccessCodeInput>,
 signal?: AbortSignal
) => {
      confirmAccessCodeInput = toValue(confirmAccessCodeInput);

      return axiosClient<StandardMessage>(
      {url: `/sessions/confirm-access-code`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: confirmAccessCodeInput, signal
    },
      );
    }




export const getVerifyConfirmAccessCodeMutationOptions = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyConfirmAccessCode>>, TError,{data: ConfirmAccessCodeInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof verifyConfirmAccessCode>>, TError,{data: ConfirmAccessCodeInput}, TContext> => {

const mutationKey = ['verifyConfirmAccessCode'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyConfirmAccessCode>>, {data: ConfirmAccessCodeInput}> = (props) => {
          const {data} = props ?? {};

          return  verifyConfirmAccessCode(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VerifyConfirmAccessCodeMutationResult = NonNullable<Awaited<ReturnType<typeof verifyConfirmAccessCode>>>
    export type VerifyConfirmAccessCodeMutationBody = ConfirmAccessCodeInput
    export type VerifyConfirmAccessCodeMutationError = ErrorType<StandardError>

    /**
 * @summary Verify confirm access code
 */
export const useVerifyConfirmAccessCode = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyConfirmAccessCode>>, TError,{data: ConfirmAccessCodeInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof verifyConfirmAccessCode>>,
        TError,
        {data: ConfirmAccessCodeInput},
        TContext
      > => {
      return useMutation(getVerifyConfirmAccessCodeMutationOptions(options), queryClient);
    }
    /**
 * @summary Send confirm access email with code
 */
export const sendConfirmAccessEmail = (

 signal?: AbortSignal
) => {


      return axiosClient<ConfirmAccessEmailResponse>(
      {url: `/sessions/confirm-access-email`, method: 'POST', signal
    },
      );
    }




export const getSendConfirmAccessEmailMutationOptions = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendConfirmAccessEmail>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sendConfirmAccessEmail>>, TError,void, TContext> => {

const mutationKey = ['sendConfirmAccessEmail'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendConfirmAccessEmail>>, void> = () => {


          return  sendConfirmAccessEmail()
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendConfirmAccessEmailMutationResult = NonNullable<Awaited<ReturnType<typeof sendConfirmAccessEmail>>>

    export type SendConfirmAccessEmailMutationError = ErrorType<StandardError>

    /**
 * @summary Send confirm access email with code
 */
export const useSendConfirmAccessEmail = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendConfirmAccessEmail>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof sendConfirmAccessEmail>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getSendConfirmAccessEmailMutationOptions(options), queryClient);
    }
